 <template>
  <SubContent @back="$router.go(-1)" height="625px" >
    <template v-slot:nav_left>
      {{matchReport.youthShortName}}-{{matchReport.squadName}}
      <span style="font-size:.16rem;margin-left:20px">比赛开始时间： {{matchReport.matchTime | time(true)}}</span>
    </template>
    <template v-slot:nav_right>
      <div v-if=" userRole !== 'player' && matchReport.matchReportStatus ==='COMPLETE' " class="download_btn" @click="download(matchReport.uuid)">下载</div>
    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          基本信息
        </div>
        <div class="item">

          <div class="col">
            <span>比赛名称：{{matchReport.matchName || '--'}}（{{matchReport.matchType || '--' }}）</span>
          </div>
          <div class="col">
            <span>比赛对手：{{matchReport.vs}}</span>
            <span>比赛结果：{{matchReport.matchResult}}（{{matchReport.goalScore}}：{{matchReport.goalConceded}}）
            </span>
            <span>比赛时长：{{parseInt(matchReport.matchTotalTime / 60)}} 小时 {{matchReport.matchTotalTime % 60}} 分钟</span>
          </div>
          <div class="col">
            <span>比赛地点：{{matchReport.matchPlace}}</span>
            <span>主要阵型：{{matchReport.teamFormation | dataEmpty}}</span>
            <span>比赛天气：{{matchReport.weather | dataEmpty}}</span>
          </div>
          <div class="col">
            <span>报告创建时间：{{matchReport.updatedAt | time(true)}}</span>
          </div>
<!--          <div class="col">-->
<!--            <span>比赛报告总体描述：<p style=" margin-top: .05rem" v-html="matchReport.overallEvalComment"></p></span>-->
<!--          </div>-->
        </div>
        <div v-if="matchReport.matchReportStatus === 'COMPLETE'">
          <div class="item_title">
            <img src="@/assets/images/common/link_icon.png" style="width:.2rem;height.2rem" alt="">
            比赛总结
          </div>
          <div class="item">
            <div class="col">
              <span>{{matchReport.matchSummary}}</span>
            </div>
          </div>
          <div class="item_title">
            <img src="@/assets/images/common/videoIcon.png" style="width:.3rem;height.3rem" alt="">
            视频
          </div>
          <div class="trainPlan">
            <div
              v-for="(item,index) in videoToPlayerVos"
              :key="index"
              class="mediaDetail"
              @click.stop="goDetail(item.uuid)">
              <div class="img">
                <img
                  class="playImg"
                  :src="playImg"
                  style="position: absolute;top: 30px;left: 65px;"
                  @click.stop="openVideoDialog(item.videoAddress,item.videoCoverAddress)">
                <img
                  class="coverImg "
                  :src="item.videoCoverAddress || planImg"
                  alt=""
                  style="width: 170px;height:100px"
                  @error="item.videoCoverAddress === planImg" >
              </div>
              <div class="intro">
                <p class="p_item">标题：{{item.videoTitle || '--'}}</p>
                <p class="p_item">上传人：{{item.authorName}}</p>
                <p >时长： {{filterTime(parseInt(item.videoDuration / 60))}}:{{ filterTime(item.videoDuration % 60)}}</p>
              </div>
            </div>
          </div>
          <yioks-empty v-show="videoToPlayerVos.length === 0" :h="'150px'"></yioks-empty>
          <div>
            <div class="item_title">
              <img src="@/assets/images/common/group_member.png" style="width:.25rem;height:.2rem" alt="">
<!--              全队球员<div v-if="Number(matchReport.commentStatus)" style="font-size:18px">（球员数量：{{players.length}}个）</div>-->
              全队球员<div style="font-size:18px">（球员数量：{{players.length}}个）</div>
            </div>
            <div v-if="Number(matchReport.commentStatus)">
              <template v-for="(item,index) in players">
                <div v-if=" userRole === 'player'? uuid === item.playerUuid : true" :key="index" class="player-box">
                  <div class="left-info-box">
                    <div class="head-img-box">
                      <img :src="item.headImgUrl ? item.headImgUrl :person " class="head-img" @error="item.headImgUrl = person">
                      {{item.idName}}
                    </div>
                    <div class="select-box">
                      <div v-if="item.attendanceTime !== 0" class="head-input-label">
<!--                        <p v-if="Number(matchReport.commentStatus)">上场时间：{{item.attendanceTime}}分钟</p>-->
                        <p>上场时间：{{item.attendanceTime}}分钟</p>
                      </div>
                      <div v-if="item.goalScore !== 0" class="head-input-label">
<!--                        <p v-if="Number(matchReport.commentStatus)">进球数：{{item.goalScore}}个</p>-->
                        <p>进球数：{{item.goalScore}}个</p>
                      </div>
                      <div v-if="item.goalAssisted !== 0" class="head-input-label">
<!--                        <p v-if="Number(matchReport.commentStatus)">助攻数：{{item.goalAssisted}}个</p>-->
                        <p>助攻数：{{item.goalAssisted}}个</p>
                      </div>
                    </div>
                  </div>
                  <div class="right-info-box">
                    <div class="row">
                      <div class="label-wrapper">
                        {{$t('allEvaluation')}}：
                      </div>
                      <div class="input-wrapper">
                        <div>{{ item.generalEvalComments || '--'}}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        技术评价：
                      </div>
                      <div class="input-wrapper">
                        <div>{{ item.technicalScore || '--' }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        战术评价：
                      </div>
                      <div class="input-wrapper">
                        <div>{{ item.tacticalScore || '--' }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        体能评价：
                      </div>
                      <div class="input-wrapper">
                        <div>{{ item.physicalScore || '--' }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        心智评价：
                      </div>
                      <div class="input-wrapper">
                        <div>{{ item.psychologicalScore || '--' }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        社交评价：
                      </div>
                      <div class="input-wrapper">
                        <div>{{item.overallScore || '--'}}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="label-wrapper">
                        {{$t('advice')}}：
                      </div>
                      <div class="input-wrapper">
                        {{ item.learningObjectives || '--' }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-else>
              <div class="item" style="margin-bottom: 5px">
                <template v-for="(item,index) in players">
                  <div class="col">
                    <span>球员姓名：{{ item.idName }}</span>
                    <span>上场时间：
                    <template v-if="item.attendanceTime !== 0">{{ item.attendanceTime }}分钟</template>
                    <template v-else>--</template>
                  </span>
                    <span>进球数：
                    <template v-if="item.goalScore !== 0">{{ item.goalScore }}个</template>
                    <template v-else>--</template>
                  </span>
                    <span>助攻数：
                    <template v-if="item.goalAssisted !== 0">{{ item.goalAssisted }}个</template>
                    <template v-else>--</template>
                  </span>
                  </div>
                </template>
              </div>
<!--              <yioks-empty :h="'150px'" :tips="'暂时没有球员评价'"></yioks-empty>-->
            </div>
          </div>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
    </div>
    <template v-if="showVideo">
      <el-dialog
        :visible.sync="showVideo"
        width="800px"
        class="linkAllDialog"
        :close-on-click-modal="false"
        top="12vh">
        <div style="text-align: center;background-color: black;width: 760px" >
          <video
            ref="video"
            controls
            width="760"
            autoplay
            disablePictureInPicture
            :poster="poster"
            controlsList = "nodownload noremoteplayback"
            height="400">
            <source :src="videoSrc" type="video/mp4">
          </video>
        </div>
      </el-dialog>
    </template>
  </SubContent>
</template>

<script>

import person from '@/assets/images/common/person.jpg'
import match from '@/api/match'
import storage from '@/utils/storage'
import common from '@/api/common'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'

export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    dataEmpty (val) {
      if (!val) return '--'; else  return val;
    },
  },
  data () {
    return {
      person,
      playImg,
      planImg,
      downIng: false,
      loading: true,
      matchReportUuid: this.$route.query.uuid,
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      matchReport: {},
      players: [],
      videoToPlayerVos: [],
      showVideo: false,
    }
  },
  created () {
    this.getMatchDetail()
  },
  methods: {
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    getMatchDetail () {
      match.getMatchReportDetail(this.matchReportUuid).then(res => {
        this.loading = false
        if (res.code) {
          this.$message.error('比赛报告不存在')
          this.$router.push('/home/index')
        } else {
          this.matchReport = res.matchReportListVo
          this.players = res.matchReportPlayerListVo
          this.videoToPlayerVos = res.videos
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    download (uuid) {
      if (this.downIng) return
      this.downIng = true
      match.downloadMatchReport(uuid).then(res => {
        const { fileName, filePath } = res
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
          common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },
    openVideoDialog (src, poster) {
      this.videoSrc = src
      this.poster = poster || ''
      this.showVideo = true
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/media/detail',
        query: {
          uuid
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .download_btn
    background $green_color2
    padding .05rem .2rem
    font-size .16rem
    cursor pointer
  .scroll_wrap
    flex 1
    overflow hidden
    box-sizing border-box
    padding .2rem 0
    .item_title
      display flex
      align-items center
      font-size .2rem
      padding .4rem 0 .2rem
      margin 0 .3rem
      span
        margin-left .4rem
        font-size .16rem
      img
        margin-right .1rem
    .item
      border 1px solid #FFF
      margin 0 .3rem
      .head
        font-weight bold
      .center
        text-align center
      .col
        display flex
        border-bottom 1px solid #FFF
        justify-content space-around
        padding .1rem .2rem
        span
          width 100%
        &:last-child
          border none
    .item_link
      border 1px solid #FFF
      margin 0 .3rem
      .col
        display flex
        border-bottom 1px solid #FFF
        &:last-child
          border none
        .title
          width: 1.5rem;
          padding .1rem .05rem
        .flex
          flex 1
          padding .1rem .2rem
          border-left 1px solid #FFF
    .trainPlan
      display flex
      justify-content space-between
      flex-wrap wrap
      margin: 0 .3rem;
      .planDetail
        border  1px solid white
        width 100%
        .row
          min-height 49px
          display flex
          align-items center
          border-bottom 1px solid white
          &:last-child
            border-bottom none
          .col
            width:  50%
            padding 0 10px 0 20px
            height 100%
            line-height 49px
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &:first-child
              border-right  1px solid white
        .rowLine
          padding: 10px  10px  10px 20px
      .mediaDetail
        background-color rgba(0,0,0,0.7)
        border  1px solid white
        padding  20px
        width 400px
        display flex
        align-items center
        cursor pointer
        margin-bottom 20px
        .p_item
          margin-bottom 10px
      .img
        width 170px
        height 100px
        position relative
        .coverImg
          width 100%
          height 100%
      .intro
        padding-left 10px
        width: calc(100% - 170px);
        height 100px
        display flex
        flex-direction column
        justify-content space-between
    .item_squad
      border 1px solid #FFF
      margin 0 .3rem .2rem
      border-right 0
      display flex
      .flex
        flex 1
      .flex_center
        display flex
        flex-direction column
        justify-content center
        align-items center
        padding 0 .1rem
        border-right 1px solid #FFF
        img
          width .6rem
          height .6rem
          border-radius 50%
          margin-bottom .1rem
        p
          margin-bottom .1rem
      .head,.content
        padding: 0.1rem 0.2rem;
        border-right 1px solid #FFF
        border-bottom 1px solid #FFF
      .content
        min-height .6rem
      .col
        display flex
        justify-content space-around
        border-bottom 1px solid #FFF
        &:last-child
          border none
        span
          width 100%
          text-align center
          border-right 1px solid #FFF
          padding .1rem .2rem

.left-wrapper
  width 100%
  .up-wrapper
    display flex
  .down-wrapper
    .line
      display flex
      border-bottom 1px solid #FFF
      &:last-child
        border-bottom none
      .title-item
        width 100%
        border-right 1px solid #FFF
        padding .1rem .2rem
        display flex
        justify-content center
        align-items center

.player-box
  border 1px solid #FFF
  display flex
  margin 0 .3rem .2rem
  .left-info-box
    width 205px
    display flex
    flex-direction column
    align-items center
    justify-content center
    .head-img-box
      width 100%
      display flex
      flex-direction column
      justify-content center
      align-items center
      .head-img
        width 80px
        height 80px
        border-radius 80px
        margin 0 10px 20px
    .select-box
      margin-top 20px
      padding 5px 10px
      .head-input-label
        display flex
        flex-direction column
        .head-input-label-text
          display flex
          align-items center
          justify-content center
  .right-info-box
    border-left 1px solid #FFF
    width 100%
    .row
      width 100%
      border-bottom 1px solid #FFFFFF
      padding 15px 10px
      display flex
      &:last-child
        border-bottom none
      .label-wrapper
        width 95px
        text-align right
      .input-wrapper
        padding 0 10px
        display flex
        width: 100%
        .input-style
          width 100%

.img-box
  padding 0rem 0 .2rem
  margin 0 .3rem
  img
    width 100%
    max-height: 500px
    max-width: 830px

</style>
